export default "__VITE_ASSET__DtHS7S0P__"